export function getDetailsFromError(error: Error): string {
  if (error.cause) {
    return error.message+"|"+error.cause.toString();
  }else{
  return error.message.toString();
  }
}
